import { render, staticRenderFns } from "./DoughnutChartWrap.vue?vue&type=template&id=628d7328&scoped=true&"
import script from "./DoughnutChartWrap.vue?vue&type=script&lang=js&"
export * from "./DoughnutChartWrap.vue?vue&type=script&lang=js&"
import style0 from "./DoughnutChartWrap.vue?vue&type=style&index=0&id=628d7328&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628d7328",
  null
  
)

export default component.exports